<template>
    <div class="row">
      <div class="col-md-8">
        <card>
          <form class="form-horizontal" @submit.prevent="updateItem">
            <h5 slot="header" class="card-title ml-7">
              Edit Room Directory
            </h5>
            <br />
  
            <div class="row mb-3">
              <div class="col-md-9">
                <label for="pdfUpload" class="img">
                  <span v-if="!pdfName">
                    <span class="btn">Choose PDF</span>
                  </span>
                  <input type="file" id="pdfUpload" @change="onFileChange" accept="application/pdf" hidden />
                </label>
                <div v-if="pdfName" class="mt-3">
                  <p>Selected File: {{ pdfName }}</p>
                  <p-button type="info outline mt-2" @click="removePdf" outline>
                    <i slot="label" class="nc-icon nc-simple-remove"></i> Delete PDF
                  </p-button>
                </div>
                <div v-if="pdfUrl" class="mt-4">
                <p><strong>Preview PDF:</strong></p>
                <iframe :src="pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0'" width="100%" height="600px" frameborder="0"></iframe>
            </div>
              </div>
            </div>
  
            <div slot="footer" class="row">
              <label class="col-md-3"></label>
              <div class="col-md-9 d-flex justify-content-end">
                <p-button type="success" round @click="updateItem" :disabled="isSubmitting">
                  Save Changes
                </p-button>
              </div>
            </div>
          </form>
        </card>
      </div>
    </div>
  </template>
  
  <script>
  import { Select, Option } from 'element-ui'
  import { Card } from 'src/components/UIComponents'
  import { Button } from 'src/components/UIComponents'
  import Swal from 'sweetalert2'
  import { doc, getDoc, setDoc } from 'firebase/firestore'
  import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'
  import { db, storage } from '@/firebase'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  
  export default {
    components: {
      PSwitch,
      [Button.name]: Button,
      Card,
      [Option.name]: Option,
      [Select.name]: Select,
    },
    data() {
      return {
        isSubmitting: false,
        pdfUrl: null,
        pdfName: null,
        file: null,
        active: true,
        form: {
          FoodName: 'Room101', // Set default or dynamically load later
          FoodType: '',
          FoodIngredients: '',
          price: '',
        },
      }
    },
    watch: {
      async active(newValue) {
        try {
          if (!this.form.FoodName) {
            console.error('Missing FoodName for update.')
            return
          }
  
          const docRef = doc(db, 'Directory', this.form.FoodName)
          await setDoc(docRef, { active: newValue }, { merge: true })
          console.log(`Document updated with active: ${newValue}`)
        } catch (error) {
          console.error('Error updating status:', error.message)
        }
      }
    },
    async mounted() {
      const id = this.form.FoodName // Can be changed to this.$route.params.id later
      if (id) {
        const docRef = doc(db, 'Directory', id)
        const docSnap = await getDoc(docRef)
  
        if (docSnap.exists()) {
          const data = docSnap.data()
          this.pdfUrl = data.PdfURL
          this.active = data.active ?? true
          if (this.pdfUrl) {
            this.pdfName = this.pdfUrl.split('/').pop().split('?')[0]
          }
        } else {
          console.warn('No such document!')
        }
      }
    },
    methods: {
      onFileChange(event) {
        const file = event.target.files[0]
        if (file && file.type === 'application/pdf') {
          this.file = file
          this.pdfName = file.name
          this.pdfUrl = URL.createObjectURL(file); // 🔥 Instant preview

        } else {
          alert('Please select a valid PDF file.')
        }
      },
      removePdf() {
        this.pdfUrl = null
        this.pdfName = null
        this.file = null
      },
      async updateItem() {
        if (!this.form.FoodName) {
          alert('Food name is required to update the directory.')
          return
        }
  
        try {
          this.isSubmitting = true
          let uploadedPdfUrl = this.pdfUrl
  
          if (this.file) {
            const storageRef = ref(storage, `directory_pdfs/${this.file.name}`)
            const snapshot = await uploadBytes(storageRef, this.file)
            uploadedPdfUrl = await getDownloadURL(snapshot.ref)
            this.pdfUrl = uploadedPdfUrl;  

          }
  
          const docRef = doc(db, 'Directory', this.form.FoodName)
          await setDoc(docRef, {
            PdfURL: uploadedPdfUrl,
            active: this.active,
            createdAt: new Date()
          }, { merge: true })
  
          Swal.fire({
            title: 'Success!',
            text: 'PDF uploaded and Directory updated!',
            icon: 'success',
            confirmButtonText: 'OK'
          })
  
          this.$router.push('/directory/edit')
          this.isSubmitting = false
        } catch (error) {
          console.error('Error updating directory:', error.message)
          alert('Error: ' + error.message)
        }
      }
    }
  }
  </script>
  